import React, { Component } from 'react';
import enumCache from '@/shared/services/EnumCacheService';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { injectIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import classNames from 'classnames';
import intlShape from '@/shared/utils/intlShape';

const messages = defineMessages({
  SelectAValue: 'Select a value',
  NoValue: 'No value',
});

class EnumSelect extends Component {
  static defaultProps = {
    orderByLabel: false,
    hideItems: [],
  };

  static propTypes = {
    intl: intlShape.isRequired,
    onChange: PropTypes.func.isRequired,
    enumType: PropTypes.string.isRequired,
    orderByLabel: PropTypes.bool,
    allowNull: PropTypes.bool,
    nullLabel: PropTypes.string,
    hideItems: PropTypes.arrayOf(PropTypes.number),
  };

  state = {
    options: [],
    selectedValue: undefined,
    allowNull: false,
    nullLabel: undefined,
  };

  componentDidMount() {
    const { intl, enumType, orderByLabel, allowNull, hideItems, nullLabel } = this.props;
    enumCache.get(enumType).then(data => {
      let options = data.map(x => ({
        id: x.key,
        label: intl.formatMessage(listItemMsg(enumType, x.key, x.value)),
      }));
      if (orderByLabel) {
        options = options.sort(dynamicSort('label'));
      }
      if (allowNull) {
        options = [
          { id: -1, label: nullLabel ? nullLabel : intl.formatMessage(messages.NoValue) },
          ...options,
        ];
      }
      if (hideItems.length > 0) {
        options = options.filter(x => !hideItems.includes(x.id));
      }
      this.setState({
        options,
      });
    });
  }

  selectedValueChanged(e) {
    const { onChange } = this.props;
    const { options } = this.state;

    const selectedOption = options.find(x => x.id === parseInt(e.target.value));
    this.setState({ selectedValue: selectedOption.id }, () =>
      onChange(selectedOption.id === -1 ? null : selectedOption.id),
    );
  }

  render() {
    const { options, selectedValue } = this.state;
    const { intl } = this.props;
    return (
      <select
        onChange={e => this.selectedValueChanged(e)}
        className="form-control"
        value={selectedValue}
      >
        {!selectedValue && selectedValue !== 0 && (
          <option value="">{intl.formatMessage(messages.SelectAValue)}</option>
        )}
        {options &&
          options.map(option => (
            <option
              key={option.id}
              value={option.id}
              className={classNames({ italic: option.id === -1 })}
            >
              {option.label}
            </option>
          ))}
      </select>
    );
  }
}

export default injectIntl(EnumSelect);
